module.exports = __webpack_public_path__ + "static/startup.a130abda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/startup.svg
// module id = 465
// module chunks = 226020273838829